export default "__VITE_ASSET__P86wgEX6__"